import React, {FC, useCallback, useContext, useState} from 'react';

import {reportView} from '../../util/urls/shared';
import * as S from './ShareReportTrigger.styles';
import {ShareReportTriggerContext} from './ShareReportTriggerContextProvider';

export const NormalLinkSection: FC = () => {
  const {view} = useContext(ShareReportTriggerContext);

  const {origin, host} = window.location;
  const pathname = reportView({
    entityName: view.project?.entityName ?? '',
    projectName: view.project?.name ?? '',
    reportID: view.id ?? '',
    reportName: view.displayName,
  });

  const [isNormalLinkAnimated, setIsNormalLinkAnimated] = useState(false);

  const animateNormalLink = useCallback(() => {
    setIsNormalLinkAnimated(false);
    setTimeout(() => {
      setIsNormalLinkAnimated(true);
    });
  }, []);

  return (
    <>
      <S.RowWrapper>
        <S.IconTextWrapper>
          <S.GrayCircleWBIcon name="link" />
          Anyone with the link can view
        </S.IconTextWrapper>
      </S.RowWrapper>
      <S.CopyableLinkWrapper>
        <S.CopyableLink
          isAnimated={isNormalLinkAnimated}
          text={`${host}${pathname}`}
          copyText={`${origin}${pathname}`}
          toastText="Link copied"
          onClick={animateNormalLink}
        />
      </S.CopyableLinkWrapper>
    </>
  );
};
